import { memo } from 'react';
import GridOrderedResources from '../common/GridOrderedResources';
import VertGolf from './VertGolf';

function GridGolfOrdered(props) {
  return (
    <GridOrderedResources
      {...props}
      VerticalComponent={VertGolf}
      showLoadingLegend={false}
      resourceType={'golf'}
      useResponsiveNearestHeader={false}
    />
  );
}

export default memo(GridGolfOrdered);
